import { combineReducers } from '@reduxjs/toolkit'
import { reducer as formReducer } from 'redux-form'
import { persistReducer } from 'redux-persist'
import sessionStorage from 'redux-persist/es/storage/session'
import localStorage from 'redux-persist/lib/storage'
import { ThunkAction } from 'redux-thunk'

import currentUserReducer from './currentUser/currentUserReducer'
import earningsReducer from './earnings/earningsReducer'
import onboardingReducer from './onboarding/onboardingReducer'
import userAuthReducer from './userAuth/userAuthReducer'
import withdrawalsReducer from './withdrawals/withdrawalsReducer'

const REDUCER_KEYS = {
	FORM: 'form',
	USER_AUTH: 'user_auth',
	CURRENT_USER: 'current_user',
	WITHDRAWALS: 'withdrawals',
	ONBOARDING: 'onboarding',
	EARNINGS: 'earnings'
}

const rootReducer = combineReducers({
	form: persistReducer(
		{
			key: REDUCER_KEYS.FORM,
			storage: sessionStorage
		},
		formReducer
	),
	userAuth: persistReducer(
		{
			key: REDUCER_KEYS.USER_AUTH,
			storage: localStorage
		},
		userAuthReducer
	),
	currentUser: persistReducer(
		{
			key: REDUCER_KEYS.CURRENT_USER,
			storage: sessionStorage
		},
		currentUserReducer
	),
	withdrawals: persistReducer(
		{
			key: REDUCER_KEYS.WITHDRAWALS,
			storage: sessionStorage
		},
		withdrawalsReducer
	),
	onboarding: persistReducer(
		{
			key: REDUCER_KEYS.ONBOARDING,
			storage: sessionStorage
		},
		onboardingReducer
	),
	earnings: persistReducer(
		{
			key: REDUCER_KEYS.EARNINGS,
			storage: sessionStorage
		},
		earningsReducer
	)
})

export default rootReducer
export type RootState = ReturnType<typeof rootReducer>
export type ThunkResult<R> = ThunkAction<R, RootState, undefined, any>
